import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectBulkSelectedRecordIds } from "../store/selector";

/**
 * Reads the current bulk selection for a view. Memoizes the per-view selector factory so
 * useSelector keeps a stable reference across renders.
 * @param {string} viewKey - the BulkActionsContainer viewKey (e.g. "all-patients")
 * @returns {{ selectedRecordIds: Array, hasSelection: boolean }}
 */
export const useBulkSelectionRecordIds = (viewKey) => {
  const selector = useMemo(() => selectBulkSelectedRecordIds(viewKey), [viewKey]);
  const selectedRecordIds = useSelector(selector);
  return { selectedRecordIds, hasSelection: selectedRecordIds.length > 0 };
};
